export const LOGO_URL = "/logo-full.png";

export const LOGO_FULL_URL = "/heritage-full.png";

export const LEGALSHIELD_LOGO = "/legalshield.png";

export const CONTACT = {
  phone: "(470) 814-0464",
  phoneHref: "tel:+14708140464",
  email: "info@heritagefamilypa.com",
  emailHref: "mailto:info@heritagefamilypa.com",
};

export const BOOKING_URL = "https://calendly.com/heritagefamilyprotect";

export const NAV_TREE = [
  { label: "Home", to: "/" },
  {
    label: "Services",
    to: "/services",
    children: [
      { label: "All Services", to: "/services" },
      { label: "Life Insurance", to: "/life-insurance" },
      { label: "Will & Trust Planning", to: "/will-and-trust" },
      { label: "Tax Services", to: "/taxes" },
      { label: "LegalShield", to: "/legalshield" },
      { label: "Healthcare Solutions", to: "/healthcare" },
      { label: "AT&T Wireless & Internet", to: "/att" },
      { label: "Vivint Home Security", to: "/vivint" },
    ],
  },
  {
    label: "About",
    to: "/about",
    children: [
      { label: "Our Story", to: "/about" },
      { label: "Meet the Owner", to: "/meet-the-owner" },
      { label: "Meet the Team", to: "/meet-the-team" },
      { label: "Our Partners", to: "/partners" },
      { label: "Community Bulletin", to: "/community" },
    ],
  },
  { label: "Careers", to: "/careers" },
  { label: "Blog", to: "/blog" },
  { label: "Book a Call", to: "/book-a-call" },
  { label: "Contact", to: "/contact" },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Life Insurance", to: "/life-insurance" },
  { label: "Will & Trust Planning", to: "/will-and-trust" },
  { label: "Tax Services", to: "/taxes" },
  { label: "LegalShield", to: "/legalshield" },
  { label: "Healthcare Solutions", to: "/healthcare" },
  { label: "About", to: "/about" },
  { label: "Meet the Owner", to: "/meet-the-owner" },
  { label: "Meet the Team", to: "/meet-the-team" },
  { label: "Our Partners", to: "/partners" },
  { label: "Community Bulletin", to: "/community" },
  { label: "Careers", to: "/careers" },
  { label: "Blog", to: "/blog" },
  { label: "Book a Call", to: "/book-a-call" },
  { label: "Contact", to: "/contact" },
];

export const SOCIALS = [
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/share/1M5uRZVDDh/?mibextid=wwXIfr" },
  { id: "instagram", label: "Instagram", url: "https://www.instagram.com/heritagefamilyprotectionagency?igsh=MW9rdWthb3JwcDNxaw%3D%3D&utm_source=qr" },
  { id: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@heritagefamilypro?_r=1&_t=ZT-98jue0T3q6I" },
  { id: "youtube", label: "YouTube", url: "https://youtube.com/@heritagefamilyprotectionagency?si=XbDcI1T-udWiuxEY" },
  { id: "linkedin", label: "LinkedIn", url: "https://www.linkedin.com/company/heritage-family-protection-agency/" },
];

export const LS = {
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/5372p8qn_primary.png",
  signup: "https://heritagefamilyprotec.legalshieldassociate.com",
  associate: "https://heritagefamilyprotec.legalshieldassociate.com/associate",
  purple: "#8231D4",
  images: {
    familyLawyer: "https://images.unsplash.com/photo-1739298061740-5ed03045b280?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    signing: "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    consult: "https://images.unsplash.com/photo-1653669487177-d7c8e245f0f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
};

export const LS_MEMBERSHIPS = [
  {
    name: "Legal Plan",
    price: "$29.95",
    per: "/month",
    note: null,
    blurb: "Simple, easy, and affordable legal access through a dedicated provider law firm network.",
    features: ["24/7 emergency access", "Letters & calls on your behalf", "Document review"],
    link: "https://heritagefamilyprotec.legalshieldassociate.com/legal",
    popular: true,
  },
  {
    name: "IDShield",
    price: "$14.95",
    per: "/month",
    note: null,
    blurb: "Proactively protect your identity, privacy, and online reputation against cybercrime.",
    features: ["Identity & credit monitoring", "Monthly credit score tracker", "Social media monitoring", "Full-service restoration"],
    link: "https://heritagefamilyprotec.legalshieldassociate.com/identity",
    popular: false,
  },
  {
    name: "Legal & Identity Bundle",
    price: "$44.90",
    per: "/month",
    note: null,
    blurb: "Complete peace of mind — a legal plan and identity protection together at a bundled rate.",
    features: ["24/7 emergency access", "Letters & calls", "Continuous credit monitoring", "Trend Micro Maximum Security"],
    link: "https://heritagefamilyprotec.legalshieldassociate.com/identity/legal",
    popular: false,
  },
  {
    name: "Small Business Plan",
    price: "$49.95",
    per: "/month",
    note: null,
    blurb: "Legal consultation, document review, debt collection letters, and legal forms for your business.",
    features: ["Calls & letters on your behalf", "Contracts & documents review", "Debt collection letters"],
    link: "https://heritagefamilyprotec.legalshieldassociate.com/smb",
    popular: false,
  },
  {
    name: "Commercial Drivers Plan",
    price: "$32.95",
    per: "/month",
    note: "+ up to $25 one-time fee",
    blurb: "For member and spouse — protection built for life on the road.",
    features: ["Traffic accident representation", "License reinstatement", "Moving violations defense"],
    link: "https://heritagefamilyprotec.legalshieldassociate.com/commercial-driver",
    popular: false,
  },
  {
    name: "Business Builder Bundle",
    price: "$49.90",
    per: "/month",
    note: "+ $99 one-time fee",
    blurb: "Legal + IDShield + the Associate Start-Up Kit — everything to begin your LegalShield business.",
    features: ["Personal & business legal support", "Comprehensive identity protection", "Tools to grow your business"],
    link: "https://heritagefamilyprotec.legalshieldassociate.com",
    popular: false,
  },
];

export const LS_SUPPLEMENTS = [
  { name: "Gun Owners Supplement", link: "https://heritagefamilyprotec.legalshieldassociate.com/legal/gun-owner" },
  { name: "Trial Defense Supplement", link: "https://heritagefamilyprotec.legalshieldassociate.com/legal/trial-defense" },
  { name: "Home Business Add-On", link: "https://heritagefamilyprotec.legalshieldassociate.com/legal/home-business" },
  { name: "Ride Share & Delivery Drivers", link: "https://heritagefamilyprotec.legalshieldassociate.com/legal/rideshare" },
];

export const LS_MEMBER_QUOTE = {
  quote: "I have been avoiding getting my Will done because it was just overwhelming. LegalShield and the Provider Lawyer they connected me with made the process so user-friendly and speedy. I can't believe I waited so long when it was so quick and easy!",
  name: "Victoria",
  context: "LegalShield Member, MA",
};

export const LS_ABOUT = [
  "For nearly 50 years, LegalShield has been on a mission to make legal protection affordable and accessible for everyone — not just those who can afford expensive hourly attorney fees. Today, LegalShield serves millions of members across North America through a network of dedicated provider law firms.",
  "As a LegalShield Independent Associate, Heritage Family Protection Agency helps individuals, families, and small-business owners connect to these plans. For a low, flat monthly rate, members gain direct access to experienced attorneys who can advise, advocate, and act on their behalf — from everyday questions to unexpected legal challenges.",
  "Whether you need a will drafted, a contract reviewed, a speeding ticket handled, or protection against identity theft, LegalShield gives your family the confidence of having a law firm in your corner — anytime you need it.",
];

export const LS_PLANS = [
  {
    id: "personal",
    name: "Personal Plan",
    tagline: "Legal protection for you & your family",
    highlight: true,
    features: [
      "Unlimited legal consultation on personal matters",
      "Legal document & contract review",
      "Letters and phone calls made on your behalf",
      "Last Will, living will & power of attorney prep",
      "Speeding & moving traffic-violation help",
      "Trial defense for covered situations",
      "24/7 emergency legal access",
      "Manage everything from the LegalShield mobile app",
    ],
  },
  {
    id: "idshield",
    name: "IDShield",
    tagline: "Identity theft protection & restoration",
    highlight: false,
    features: [
      "24/7 identity, credit & financial monitoring",
      "Real-time threat alerts",
      "Dark-web & social-media monitoring",
      "Licensed private investigators on your side",
      "Full-service identity restoration",
      "Up to $3 million in protection",
      "Individual & family coverage options",
      "Monitor and respond from the mobile app",
    ],
  },
  {
    id: "business",
    name: "Small Business Plan",
    tagline: "Legal support for entrepreneurs",
    highlight: false,
    features: [
      "Legal consultation on business matters",
      "Business document & contract review",
      "Debt-collection letters on your behalf",
      "Legal correspondence with vendors & clients",
      "Designated provider law firm for your business",
      "Guidance on employees, leases & agreements",
      "Trademark & business filing direction",
      "Protect your business alongside your family",
    ],
  },
];


export const SERVICES = [
  {
    id: "life",
    title: "Life Insurance",
    tagline: "Love, made permanent.",
    body:
      "We help clients explore a full range of life insurance built to replace income, cover final expenses, and leave a tax-free legacy for the people who matter most.",
    points: ["Term & whole life", "Universal & indexed universal life", "Final-expense & children's plans", "Income replacement & legacy"],
  },
  {
    id: "retirement",
    title: "Retirement Planning",
    tagline: "A future without compromise.",
    body:
      "Build a retirement strategy engineered for certainty. We design tax-advantaged income streams, annuities, and 401(k)/IRA rollovers so your golden years are funded on your terms — never the market's.",
    points: ["Guaranteed lifetime income", "IRA & 401(k) rollovers", "Tax-efficient distribution", "Legacy & estate alignment"],
  },
  {
    id: "health",
    title: "Healthcare Solutions",
    tagline: "Featuring MightyWell Health.",
    body:
      "Modern healthcare memberships through MightyWell Health and KonnectMD — 24/7 virtual care with $0 copays, everyday copay coverage, and real protection for major medical events, all without traditional insurance headaches.",
    points: ["MightyWell Copay, HSA & Concierge bundles", "24/7 virtual urgent care — $0 copay", "Nationwide open network — pick your doctors", "KonnectMD virtual care memberships"],
    link: "/healthcare",
    linkLabel: "Explore healthcare plans",
  },
  {
    id: "mortgage",
    title: "Mortgage Protection",
    tagline: "Keep the front door.",
    body:
      "Coverage that may help your family continue making mortgage payments, reduce household debt, and keep their home if a covered loved one passes away.",
    points: ["Mortgage payoff benefit", "Disability & job-loss riders", "Return-of-premium", "Any lender accepted"],
  },
  {
    id: "legal",
    title: "LegalShield",
    tagline: "Legal protection made affordable.",
    body:
      "Affordable legal service memberships powered by LegalShield — giving families and businesses access to attorneys for everyday and unexpected legal needs.",
    points: ["Legal consultations & letters", "Wills & Power of Attorney", "Identity-theft protection", "Small-business legal support"],
    legalshield: true,
  },
  {
    id: "tax",
    title: "Tax Services",
    tagline: "Keep more of what you earn.",
    body:
      "Tax filing, preparation, and year-round planning for individuals, families, and small businesses — helping you stay compliant and maximize every eligible benefit.",
    points: ["Personal & business returns", "Proactive tax planning", "Maximized deductions", "IRS filing & support"],
  },
  {
    id: "wireless",
    title: "Wireless & Internet",
    tagline: "AT&T for home & business.",
    body:
      "As an AT&T Authorized Dealer, we deliver wireless plans, the latest devices, and fiber internet for both residential and business customers — with pre-order, trade-in, and hero discounts handled for you.",
    points: ["Residential & business wireless", "AT&T Fiber & Internet Air", "Latest phones, tablets & watches", "Trade-in & promo pricing"],
    link: "/att",
    linkLabel: "Explore AT&T services",
  },
  {
    id: "willtrust",
    title: "Will & Trust Planning",
    tagline: "Your legacy, in writing.",
    body:
      "A will and trust make your wishes law — and paired with life insurance, they make sure the money is there the moment your family needs it. We help you put the full plan together, hand in hand.",
    points: ["Wills & living trusts", "Beneficiary alignment", "Probate avoidance strategies", "Works hand in hand with life insurance"],
    link: "/will-and-trust",
    linkLabel: "Learn about wills & trusts",
  },
];

export const LIFE_OPTIONS = [
  { name: "Term Life Insurance", desc: "Affordable coverage for a set period to protect income during your family's most vulnerable years." },
  { name: "Whole Life Insurance", desc: "Permanent, lifelong protection with guaranteed cash value that grows over time." },
  { name: "Universal Life Insurance", desc: "Flexible permanent coverage that lets you adjust premiums and death benefit as life changes." },
  { name: "Indexed Universal Life (IUL)", desc: "Permanent protection with cash-value growth linked to market indexes — with downside protection." },
  { name: "Final-Expense Coverage", desc: "Smaller, simplified policies designed to cover funeral and burial costs so loved ones aren't burdened." },
  { name: "Children's Life Insurance", desc: "Lock in low rates and insurability for your children while building cash value for their future." },
  { name: "Income-Replacement Protection", desc: "Coverage sized to replace lost income and keep your household running if the unexpected happens." },
  { name: "Legacy Planning", desc: "Strategies designed to help families leave a tax-advantaged financial legacy for the next generation." },
];

export const LEGALSHIELD_SERVICES = [
  "Legal consultations on unlimited personal matters",
  "Document reviews and contract analysis",
  "Attorney letters and phone calls made on your behalf",
  "Will preparation and annual updates",
  "Power of Attorney services",
  "Family-law assistance",
  "Traffic-related and moving-violation services",
  "Landlord and tenant support",
  "Consumer protection matters",
  "Small-business legal services",
  "Identity-theft protection, monitoring & restoration",
  "Additional optional services by plan and location",
];

export const CARRIERS = [
  { name: "Transamerica", domain: "transamerica.com", blurb: "A century-strong carrier known for competitive term life and indexed universal life built for growing families." },
  { name: "Mutual of Omaha", domain: "mutualofomaha.com", blurb: "Trusted since 1909 — an industry leader in final expense, guaranteed issue, and senior protection." },
  { name: "SBLI", domain: "sbli.com", blurb: "The Savings Bank Life Insurance company — dependable, affordable term life coverage since 1907." },
  { name: "American General", domain: "corebridgefinancial.com", blurb: "Part of Corebridge Financial — a broad portfolio of term and permanent life solutions with flexible underwriting." },
  { name: "American Amicable", domain: "american-amicable.com", blurb: "Waco, Texas-based since 1910 — simplified-issue life products designed for everyday families." },
  { name: "Occidental Life", domain: "occidentallife.com", blurb: "An American-Amicable family brand offering accessible, no-exam life insurance options." },
  { name: "United Home Life", domain: "unitedhomelife.com", blurb: "Simplified-issue whole life and term with fast approvals — protection without the paperwork." },
  { name: "Gerber Life", domain: "gerberlife.com", blurb: "Famous for the Grow-Up Plan — children's whole life plus family coverage since 1967." },
  { name: "Fidelity & Guaranty", domain: "fglife.com", blurb: "F&G annuities and life insurance — retirement income and legacy solutions since 1959." },
  { name: "Symmetry Financial Group", domain: "sfglife.com", logo: "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/g0jkf2n6_IMG_1956.webp", blurb: "Our partner agency network — unlocking access to 30+ carriers and proven mortgage protection programs." },
];

export const OWNER = {
  name: "Eric Grainger",
  title: "Agency Owner",
  email: "eric.grainger@heritagefamilypa.com",
  photo:
    "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/ng9bze3h_a902e4df-5091-4583-aec2-a7e5f3309c84.png",
  bio: "Eric Grainger was born on January 4, 1990, in Louisville, Kentucky. He is a devoted husband to his beautiful wife, Markayla, a proud father of eight children, and a passionate advocate for helping families build greater financial security and protection for the future.",
};

export const OWNER_STORY = [
  "Throughout his professional career, Eric has developed a strong background in leadership, customer service, and working directly with people from all walks of life. He previously served as a District Manager with AT&T, where he gained valuable experience in leadership, team development, business operations, and helping others achieve their goals.",
  "After leaving the telecommunications industry, Eric spent approximately a year working in the security field. Although he valued the experience, he knew he wanted to pursue a career that would allow him to make a deeper and more meaningful impact on the lives of families.",
  "In 2024, Eric and his family relocated to Atlanta, Georgia, beginning a new chapter personally and professionally. It was during this season of his life that he made the decision to enter the financial services industry with one primary mission: to help educate, protect, and prepare families before life's unexpected moments occur.",
  "That mission became even more personal following the passing of Eric's mother.",
  "Experiencing the pain of losing a loved one gave Eric an even greater understanding of how emotionally and financially difficult a death can be for a family. Beyond the grief, many families suddenly find themselves trying to determine how they will pay for funeral expenses, outstanding bills, household expenses, mortgages, and other financial responsibilities.",
  "Eric did not want families to have to depend solely on donations, fundraisers, or online crowdfunding campaigns during one of the most difficult moments of their lives.",
  "From that experience and passion, Heritage Protection Agency was created.",
  "Heritage Protection Agency was founded with a purpose that goes beyond selling financial products. Eric's vision is to build an agency centered around family, education, preparation, protection, and legacy.",
  "His goal is to help individuals and families understand the importance of having proper financial protection in place while they still have the opportunity to prepare. Through the agency, Eric is committed to connecting families with solutions designed to help protect their loved ones, their income, their homes, and the legacies they are working so hard to build.",
  "As a husband and father of eight, Eric understands personally that protecting a family is about more than money. It is about creating peace of mind and knowing that the people you love have a plan in place if life unexpectedly changes.",
  "Eric believes that every family deserves the opportunity to be educated about their options, regardless of their background or financial situation. His approach is centered around listening to families, understanding their needs, and helping them explore solutions that make sense for their individual circumstances.",
  "His journey from Louisville to Atlanta, from corporate leadership to security, and ultimately into financial services has shaped the mission he carries today:",
];

export const OWNER_MISSION = "Protect families. Educate communities. Prepare for the unexpected. Build a legacy that lasts for generations.";

export const OWNER_STORY_CLOSE = [
  "For Eric Grainger, Heritage Protection Agency is more than a business. It is a mission born from personal experience, family, love, and the desire to make sure other families have someone standing beside them before life's most difficult moments arrive.",
  "Because protecting your family today can help preserve your family's legacy tomorrow.",
];

export const ABOUT_STORY = [
  "Heritage Family Protection Agency is a family-focused protection and financial services agency dedicated to helping individuals, families, homeowners, and business owners prepare for life's expected and unexpected challenges. Our mission is to provide trusted guidance, personalized service, and access to valuable protection solutions that can help create greater financial security, stability, and peace of mind.",
  "Founded in 2026 with a vision to build a service-driven organization centered on education, integrity, and family protection, the agency is currently led by Agency Owner Eric Grainger, who continues to oversee operations, training, and client service development while expanding the agency's reach to serve more families across multiple states.",
  "We help clients explore a variety of life insurance options — including term, whole, universal, and indexed universal life, final-expense coverage, children's life insurance, income-replacement protection, and legacy planning. We also provide mortgage protection that may help families continue making mortgage payments, reduce household debt, and protect their homes if a covered loved one passes away.",
  "In addition, we help individuals and families access affordable healthcare solutions through KonnectMD — 24/7 virtual healthcare memberships with free prescriptions and $0 copays for individuals, families, and businesses. Availability and benefits may vary based on the selected plan.",
  "We also offer affordable legal service memberships powered by LegalShield, which may provide access to legal consultations, document reviews, attorney letters and calls, Will preparation, Power of Attorney services, family-law assistance, traffic services, landlord/tenant support, consumer protection, small-business legal services, identity-theft protection, and more depending on the selected plan and location.",
  "At Heritage Family Protection Agency, we believe protection should be understandable, accessible, and personalized. We take the time to learn about each client's needs, goals, family responsibilities, and budget before connecting them with available solutions — serving with professionalism, integrity, compassion, and respect.",
  "We are more than a protection agency. We are a resource for families, a partner in the community, and a team committed to helping people protect their health, income, homes, legal rights, loved ones, and future.",
];

export const TARGET_CUSTOMERS = [
  "Parents and guardians who want financial protection and stability for their children and families",
  "Individuals seeking term, whole, universal, indexed universal, or final-expense life coverage",
  "Families concerned about funeral costs, unpaid bills, household debt, and income replacement after a loss",
  "Homeowners who want mortgage protection to help their family remain in their home",
  "Renters and homeowners who want financial protection for unexpected life events",
  "Individuals who have no life insurance or may be underinsured through employer benefits",
  "People who recently married, bought a home, had a child, changed jobs, or retired",
  "Seniors and adults seeking final-expense or burial insurance to ease the burden on loved ones",
  "Families seeking affordable healthcare solutions through KonnectMD virtual care memberships",
  "Self-employed individuals, freelancers, and small-business owners needing protection solutions",
  "Individuals and families interested in affordable legal services through LegalShield memberships",
  "Renters, drivers, employees, parents, and business owners needing everyday legal support",
  "Individuals and families interested in identity-theft protection, monitoring, and restoration",
  "People who want to build or preserve a financial legacy for future generations",
  "Individuals seeking retirement planning for long-term security and income stability",
  "Individuals and families needing tax filing, preparation support, and compliance guidance",
  "Homeowners and buyers seeking mortgage protection to safeguard their home and family",
  "Anyone seeking professional guidance to choose protection options that fit their needs and budget",
];

export const CAREERS_LOOKING = [
  "Individuals interested in starting a career in insurance and financial services",
  "People seeking a flexible, performance-based business opportunity",
  "Parents, caregivers, students, retirees, and professionals looking for additional income",
  "Individuals interested in working remotely or building a home-based business",
  "Licensed insurance professionals seeking to expand services and grow their client base",
  "Unlicensed individuals willing to complete training and obtain required state licensing",
  "Entrepreneurs who want to build, grow, and lead their own team",
  "Community-minded individuals who enjoy educating, guiding, and helping others",
  "People with experience in customer service, sales, healthcare, banking, real estate, legal, or business development",
  "Individuals comfortable discussing important financial protection needs with families",
  "Dependable, organized, goal-oriented people willing to follow a proven training system",
  "Coachable individuals eager to learn and committed to professional standards",
  "People who want to make a meaningful impact in their communities",
  "Those seeking leadership development, personal growth, and advancement opportunities",
];

export const HERITAGE_APPLY_URL = "https://form.jotform.com/261494040079053";

export const LS_ASSOCIATE_PERKS = [
  "Be your own boss with a flexible schedule — work full-time or part-time, from anywhere",
  "Earn uncapped, performance-based commissions on every membership",
  "Build long-term residual income from renewals and your growing team",
  "Low startup cost — no inventory, no overhead, no cold-calling scripts required",
  "Sell products families genuinely need: legal protection and identity theft coverage",
  "World-class training, mentorship, and a proven system to follow",
  "Recruit, build, and lead your own team for leadership overrides and bonuses",
  "Qualify for incentive trips, recognition, and performance rewards",
  "No prior experience required — we help you get started",
  "Make a real impact by giving families access to affordable legal help",
];

export const HFPA_VALUES = [
  {
    letter: "H",
    word: "Heritage",
    body: "Everything you've built deserves to outlive you. We help families turn a lifetime of hard work into a legacy that's passed down with intention.",
  },
  {
    letter: "F",
    word: "Family",
    body: "Family comes first — always. Every plan we design starts with the people around your table and what they would need if life changed tomorrow.",
  },
  {
    letter: "P",
    word: "Protection",
    body: "Protection is more than a policy. It's life, health, legal, retirement, and tax working together as one shield around your household.",
  },
  {
    letter: "A",
    word: "Agency",
    body: "Agency means advocacy. As an independent agency, we work for you — not a carrier — matching your family with coverage that truly fits.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "We listen before we protect.",
    body:
      "Every family carries a different story, a different fear, a different dream. We start with a conversation — not a quota — mapping exactly what stands between you and true security.",
  },
  {
    n: "02",
    title: "We build the whole shield.",
    body:
      "Life, health, mortgage, retirement, legal and tax are not separate products — they are one plan. We assemble them into a single, seamless line of defense around everything you've built.",
  },
  {
    n: "03",
    title: "We stay for the long game.",
    body:
      "Protection isn't a signature; it's a relationship. As your family grows and your legacy compounds, we're there to adjust, defend, and deliver when it counts most.",
  },
];

export const KMD = {
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/olt3thp4_523e5b_2c2c55cda3a64e8998e96c39eab342b2~mv2.png",
  banner: "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/ryqadep9_2AE54585-E087-4B53-A06F-7E0B70B07A24.png",
  signup: "https://www.konnectmdnow.com/Heritagefamilyprotectionagency",
  ambassador: "https://www.konnectmdagency.com/heritagefamilyprotectionagency",
  blue: "#1173b9",
  lightBlue: "#6db6e8",
  red: "#d9403a",
};

export const KMD_FEATURES = [
  { icon: "MonitorSmartphone", title: "Talk to a Doctor Virtually", desc: "Connect with board-certified physicians from the comfort of your home." },
  { icon: "ClipboardList", title: "Prescriptions When Needed", desc: "Get the medications you need, when you need them." },
  { icon: "Pill", title: "Free Prescriptions with Each Plan", desc: "Enjoy free prescription benefits included with every plan." },
  { icon: "Clock", title: "24/7 Access to a Physician", desc: "Medical care and support available 24 hours a day, 7 days a week." },
  { icon: "ShieldPlus", title: "Quality Care You Can Trust", desc: "Compassionate care from trusted, licensed professionals." },
  { icon: "Zap", title: "Convenient. Fast. Reliable.", desc: "Skip the waiting room. Get care that fits your busy life." },
];

export const KMD_ABOUT = [
  "KonnectMD is affordable, 24/7, national virtual healthcare that's easy, accessible, and affordable — with no visit fees and no prescription costs. Members enjoy unlimited access to licensed providers, prescriptions, and wellness services nationwide.",
  "Telehealth is the fastest, safest, and most effective way to get healthcare, reducing the need for in-person visits. KonnectMD provides access to providers for urgent care, primary care, and dermatology needs from anywhere in the country.",
  "As a partner of Heritage Family Protection Agency, KonnectMD helps individuals, families, and small businesses experience quicker health outcomes with less stress — for a simple, predictable monthly rate with no copays, deductibles, or hidden costs.",
];

export const KMD_SERVICES = [
  { title: "Telehealth Services", desc: "A 'virtual first' approach — access urgent care, primary care, and dermatology providers from anywhere in the country, day or night." },
  { title: "Prescription Treatments", desc: "Save up to 70% off retail medication prices, with access to nearly 1,000 of the most common acute and chronic care medications at no cost." },
  { title: "Medical Service Discounts", desc: "Up to 60% off dental, vision, laboratory, and chiropractic services to keep your whole family healthy." },
  { title: "EAP & Wellness Programs", desc: "Support for mental health, substance abuse, financial and legal challenges, and family concerns — for a happier, healthier household." },
  { title: "Online Vet Services", desc: "Virtual veterinary telemedicine for non-emergency pet questions, behavioral advice, and condition management support." },
];

export const KMD_AGENTS = [
  {
    name: "Eric Grainger",
    title: "Agency Owner",
    email: "eric.grainger@heritagefamilypa.com",
    photo:
      "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/ng9bze3h_a902e4df-5091-4583-aec2-a7e5f3309c84.png",
    url: "https://www.konnectmdnow.com/Heritagefamilyprotectionagency",
  },
  {
    name: "Markayla Grainger",
    title: "Agency Administrator",
    email: "markayla.grainger@heritagefamilypa.com",
    photo:
      "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/k4ah1ze0_414936A4-4C1E-4054-89AC-BE9627EF412C.PNG",
    url: "/konnectmd/mgrainger",
  },
];

export const KMD_STATS = [
  { value: "15,000+", label: "Certified Physicians Nationwide" },
  { value: "1,000+", label: "Common Medications Included Free" },
  { value: "90%", label: "Potential Savings on Healthcare" },
  { value: "$0", label: "Copays for Telehealth Consults" },
];

export const FOUNDERS = {
  photo:
    "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/6o473omh_52ACD780-FBE7-4942-B044-12D68885C1DA.png",
  paragraphs: [
    "Heritage Family Protection Agency is led by Eric and Markayla Grainger — a husband-and-wife team, parents of eight, and partners in a shared mission: making sure no family faces life's hardest moments unprepared.",
    "Eric, the agency's founder and owner, brings years of leadership and a deeply personal 'why' shaped by the loss of his own mother. Markayla, a licensed financial services producer and the agency's administrator, ensures every client experience is organized, attentive, and genuinely caring.",
    "Together they've built more than an agency — they've built a family serving families. When you work with Heritage, you're not handed off to a call center. You sit down with people who understand firsthand what it means to protect the ones you love.",
  ],
};

export const TEAM_MEMBERS = [
  {
    name: "Markayla Grainger",
    title: "Agency Administrator & Licensed Financial Services Producer",
    shortTitle: "Agency Administrator",
    email: "markayla.grainger@heritagefamilypa.com",
    photo:
      "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/k4ah1ze0_414936A4-4C1E-4054-89AC-BE9627EF412C.PNG",
    bio: [
      "Markayla Grainger is a dedicated licensed financial services producer and the Agency Administrator of Heritage Family Protection Agency. As the wife of agency owner Eric Grainger, she plays an important role in supporting the agency's mission of helping families become financially prepared, protected, and confident about their future.",
      "Markayla has a true passion for serving others and ensuring that every client receives professional, organized, and attentive service. Her commitment is to make sure each family is properly assisted, informed, and ready to receive the protection and financial solutions that best fit their individual needs.",
      "Through her leadership, compassion, and attention to detail, Markayla helps create a welcoming and dependable experience for every client who connects with Heritage Family Protection Agency. Her goal is simple: to make sure every family feels valued, supported, and prepared for the future.",
    ],
  },
  {
    name: "Aleisha Green",
    title: "KonnectMD Coordinator",
    shortTitle: "KonnectMD Coordinator",
    email: "aleisha.green@heritagefamilypa.com",
    photo:
      "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/5az66di1_A798CCDD-1675-40A0-BD19-BF74C15071C7.png",
    bio: [
      "Aleisha Green is an entrepreneur and healthcare advocate passionate about helping individuals, families, and business owners access convenient, affordable virtual healthcare. Through KonnectMD, she connects communities with healthcare solutions designed to fit everyday life.",
    ],
  },
  {
    name: "Wanda Wallace",
    title: "Agency Business Consultant",
    shortTitle: "Agency Business Consultant",
    photo:
      "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/5x1j6q25_ChatGPT%20Image%20Aug%2011%2C%202026%2C%2006_20_35%20PM.png",
  },
  {
    name: "Brenda Stump",
    title: "KonnectMD Agent",
    shortTitle: "KonnectMD Agent",
    email: "brenda.stump@heritagefamilypa.com",
    photo:
      "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/5fhxb2tr_ChatGPT%20Image%20Aug%2012%2C%202026%2C%2001_50_02%20AM.png",
  },
  {
    name: "Ja'Shone Williams",
    title: "KonnectMD Agent",
    shortTitle: "KonnectMD Agent",
    email: "jashone.williams@heritagefamilypa.com",
    photo:
      "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/lu2kad3g_ChatGPT%20Image%20Aug%2012%2C%202026%2C%2012_23_31%20AM.png",
  },
];

export const TEAM_PLACEHOLDERS = [
  { role: "Licensed Agent" },
];

export const HELPING_FAMILIES = {
  image:
    "https://static.prod-images.emergentagent.com/jobs/a0323fc5-7f57-4625-b860-073d0f8b9fc9/images/620799c90a31f79f1eb30458877cb38c73fbc6f69fcf301c1424239cd2200323.jpeg",
  paragraphs: [
    "Every plan we build starts with a family — their home, their income, their dreams for the next generation. We take the time to understand what you've built and what it would take to protect it, then match you with solutions that fit your budget and your life.",
    "From replacing lost income and paying off a mortgage, to covering final expenses, securing affordable healthcare and legal help, and building a retirement that lasts — we walk beside families at every stage of the journey.",
  ],
  points: [
    "Free, no-pressure protection reviews for every family",
    "Coverage designed around your household, income & goals",
    "Guidance through claims and life's hardest moments",
    "One trusted team for life, health, legal, retirement & taxes",
  ],
};

export const KMD_AMBASSADOR_PERKS = [
  "Share affordable virtual healthcare memberships families and businesses actually need",
  "Earn commissions on every membership you enroll — plus recurring monthly residuals",
  "Work from anywhere, on your own schedule — full-time or part-time",
  "No insurance license required to get started as an ambassador",
  "Offer plans starting at $59.99/month with free prescriptions and $0 copays",
  "Help small businesses give employees healthcare from just $2/day",
  "Simple online enrollment tools and a dedicated back office",
  "Pair KonnectMD with life insurance and LegalShield for a complete protection offer",
];

export const TESTIMONIALS = [
  {
    quote: "After my husband passed, the policy Heritage set up kept us in our home. They didn't just sell us coverage — they walked us through the hardest season of our lives.",
    name: "Tanya R.",
    context: "Mortgage Protection Client",
  },
  {
    quote: "Eric sat at our kitchen table and explained every option in plain English. For the first time, we actually understand what our life insurance does for our kids.",
    name: "Marcus & Danielle W.",
    context: "Young Family, Term Life",
  },
  {
    quote: "The LegalShield membership paid for itself in the first month. One call and a lawyer handled a contract issue that had been keeping me up at night.",
    name: "Gloria S.",
    context: "Small-Business Owner",
  },
  {
    quote: "They helped my mother get final-expense coverage other agencies said she was too old for. Professional, patient, and genuinely kind.",
    name: "Devon P.",
    context: "Final-Expense Coverage",
  },
];

export const LS_COMPARISON = {
  columns: ["personal", "idshield", "business"],
  labels: { personal: "Personal Plan", idshield: "IDShield", business: "Small Business" },
  rows: [
    { feature: "Unlimited legal consultation", personal: true, idshield: false, business: true },
    { feature: "Document & contract review", personal: true, idshield: false, business: true },
    { feature: "Letters & calls on your behalf", personal: true, idshield: false, business: true },
    { feature: "Will, living will & power of attorney", personal: true, idshield: false, business: false },
    { feature: "Traffic violation assistance", personal: true, idshield: false, business: false },
    { feature: "Trial defense for covered situations", personal: true, idshield: false, business: false },
    { feature: "24/7 emergency legal access", personal: true, idshield: false, business: true },
    { feature: "Identity, credit & financial monitoring", personal: false, idshield: true, business: false },
    { feature: "Dark-web & social-media monitoring", personal: false, idshield: true, business: false },
    { feature: "Full-service identity restoration", personal: false, idshield: true, business: false },
    { feature: "Up to $3M identity protection", personal: false, idshield: true, business: false },
    { feature: "Debt-collection letters", personal: false, idshield: false, business: true },
    { feature: "Designated provider law firm", personal: true, idshield: false, business: true },
    { feature: "Trademark & business filing direction", personal: false, idshield: false, business: true },
    { feature: "Mobile app access", personal: true, idshield: true, business: true },
    { feature: "Family coverage options", personal: true, idshield: true, business: false },
  ],
};

export const KMD_PLANS = [
  {
    name: "Silver",
    price: "$59.99",
    tagline: "Basic virtual healthcare for urgent care needs, acute meds & exclusive discounts",
    features: [
      "24/7 quick access to physicians",
      "Most common acute meds free",
      "Up to 80% off all other prescriptions",
      "Discounts on dental, vision, labs & chiropractic",
      "VIP patient advocacy",
    ],
    badge: null,
  },
  {
    name: "Gold",
    price: "$79.99",
    tagline: "All Silver benefits, plus 13 specialists, mental healthcare & mental health meds",
    features: [
      "24/7 on-demand counseling",
      "Common mental health meds included",
      "Short-term therapy (virtual or in-person)",
      "Psychiatry & psychology discounts",
      "Access to specialists",
    ],
    badge: "Most Popular",
  },
  {
    name: "Platinum",
    price: "$99.99",
    tagline: "All Gold benefits, plus comprehensive preventative care & disease management",
    features: [
      "Dedicated primary care physician",
      "1,000+ chronic meds free",
      "Complimentary CMP labs 2x/year per adult",
      "Checkups, preventative & chronic care",
      "Dermatology benefits — no referral needed",
    ],
    badge: "Most Value",
  },
  {
    name: "Titanium",
    price: "$149.99",
    tagline: "All Platinum benefits, plus premium concierge & lifestyle rewards",
    features: [
      "24/7 vet access & pet discounts",
      "Medical bill advocate",
      "All healthcare benefits included",
      "Exclusive shopping, dining & travel discounts",
      "10% travel rebate on cruises + 100 Room Coins/mo",
    ],
    badge: "Best Value",
  },
];

export const KMD_ADDONS = [
  { name: "Medical Bill Advocate", price: "$29.99", desc: "Expert negotiators who shrink — and often eliminate — hospital and provider bills. Average 60% reduction." },
  { name: "Concierge Pet Care", price: "$19.99", desc: "Unlimited access to board-certified veterinarians for advice, emergencies, behavior, and skin conditions." },
  { name: "VIP Booking Engine", price: "$49.99", desc: "Luxury travel access: resort weeks under $500, 10% back on cruises, and hotel & activity discounts." },
  { name: "Lifestyle Membership", price: "$99.99", desc: "Exclusive shopping & dining discounts, travel savings, VIP urgent care, and free acute medications." },
  { name: "GLP-1 Weight Loss", price: "$375/mo", desc: "All-inclusive program: labs, monthly provider check-ins, and all program meds home-delivered." },
];

export const FAQS = [
  {
    q: "How much does life insurance cost?",
    a: "Less than most people think. Rates depend on your age, health, coverage amount, and policy type — term policies for healthy adults often start around the cost of a few coffees a month. We shop multiple A-rated carriers to find the best rate for your budget, and quotes are always free.",
  },
  {
    q: "How does the quote process work?",
    a: "Simple: fill out our quick quote form (takes about a minute), and a licensed member of our team reviews your information and reaches out within one business day. We compare options across carriers, explain everything in plain English, and there's never any pressure or obligation.",
  },
  {
    q: "What type of coverage is right for me?",
    a: "It depends on your season of life. Term life is great for affordable protection during working years; whole and universal life build lifelong value; final-expense plans cover funeral costs; mortgage protection keeps your family in their home. We'll help you match coverage to your family, income, and goals.",
  },
  {
    q: "Do I need a medical exam to get covered?",
    a: "Not always. Many of the policies we offer are simplified-issue — meaning just a few health questions and no medical exam. Final-expense and some term policies can often be approved within days.",
  },
  {
    q: "What is LegalShield and how does the membership work?",
    a: "LegalShield gives you access to a dedicated provider law firm for one flat monthly rate starting at $14.95/month — legal advice, document review, will preparation, letters on your behalf, and more. It's like having a lawyer in the family, without hourly fees.",
  },
  {
    q: "What does a KonnectMD membership include?",
    a: "24/7 virtual access to board-certified physicians, over 1,000 common medications included free, and no copays or visit fees — no insurance required. Plans start at $59.99/month and cover your partner and children under 26.",
  },
  {
    q: "Which states do you serve?",
    a: "We serve families across multiple states and are expanding. Availability of specific carriers, plans, and programs varies by state — reach out and we'll confirm what's available where you live.",
  },
  {
    q: "Does it cost anything to talk to you?",
    a: "Never. Consultations, protection reviews, and quotes are completely free. You only ever pay the premium of a policy or membership you choose to start — and we'll never pressure you into one.",
  },
];

export const STATS = [
  { value: "2026", label: "Proudly Founded" },
  { value: "Multi", label: "States Served" },
  { value: "8", label: "Protection Pillars" },
  { value: "A+", label: "Carrier Ratings Only" },
];
